import { TagModel } from '@app/types/TagModel'
import { useClient, useQuery } from '@based/sdk/react'
import { useCallback, useMemo } from 'react'
import { TagSelectionGroup } from '../shared/TagSelectionGroup'
import { useEditContainerClose } from '../shared/useEditContainerClose'

export type DevelopmentFormEditProps = {
  initiativeId: number
  selectedId: number | undefined
}

export const DevelopmentFormEdit = ({
  initiativeId,
  selectedId,
}: DevelopmentFormEditProps) => {
  const closeFromContainer = useEditContainerClose()
  const onClose = closeFromContainer ?? undefined
  if (!onClose) {
    throw new Error(
      'DevelopmentFormEdit requires `onClose` or an `EditContainer` ancestor',
    )
  }

  const client = useClient()

  const developmentFormsQuery = useQuery('list-development-forms')

  const allTags: TagModel<number>[] = useMemo(
    () =>
      (developmentFormsQuery.data ?? []).map(
        (item: { id: number; name: string }) => ({
          key: item.id,
          value: item.name,
        }),
      ),
    [developmentFormsQuery.data],
  )

  const saveDevelopmentForm = useCallback(
    (selectedIds: number[]): Promise<boolean> =>
      client.call('edit-initiative', {
        id: initiativeId,
        value: {
          developmentForm:
            selectedIds.length > 0 ? { id: selectedIds[0] } : null,
        },
      }),
    [client, initiativeId],
  )

  return (
    <TagSelectionGroup
      allTags={allTags}
      selectedIds={selectedId === undefined ? [] : [selectedId]}
      onClose={onClose}
      onSave={saveDevelopmentForm}
      mode="single"
    />
  )
}
